<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Placówki'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-facility-details-view *ngIf="!modify"
                               [facility]="facility"
                               [facilityDobryAgent]="facilityDobryAgent"
                               (modifyClicked)="modify = true"
    ></app-facility-details-view>
    <app-facility-add *ngIf="modify" [partnerFacility]="facility"
                      (closeModification)="modify = false; loadFacility()"></app-facility-add>
  </mat-tab>
  <mat-tab label="OFWCA">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).ofwca.write" mat-stroked-button color="primary"
              class="ofwca-add-button" (click)="addOfwca()">
        <mat-icon>add</mat-icon>
        Dodaj OFWCA
      </button>

      <app-ofwcas-list [excludeColumns]="['facility', 'competitionRequirementsMet', 'ASF360']" [ofwcas]="ofwcas"
                       (changed)="loadOfwcas()"></app-ofwcas-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Weryfikacja procesu sprzedaży" *ngIf="!profitFacility">
    <ng-template matTabContent>

      <app-all-facilities-verification-sales-process-list [facility]="facility"
                                                          [facilityObject]="facilityObject"></app-all-facilities-verification-sales-process-list>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="(this.userApplicationPermission | async).dobryagent.active && partnerTagGoodAgent">
    <ng-template mat-tab-label>
      <span>Konfiguracja wizytówki DA </span>&nbsp;
      <mat-chip *ngIf="hasPendingVerification" color="accent" selected matTooltip=" Do weryfikacji"> Do weryfikacji
      </mat-chip>

    </ng-template>
    <mat-tab-group>
      <mat-tab label="Dane placówki ">

        <app-dobry-agent-facility-view *ngIf="!modifyFacilityDobryAgent" [facility]="facility"
                                       [facilityDobryAgent]="facilityDobryAgent"
                                       (modifyClicked)="modifyFacilityDobryAgent = true"></app-dobry-agent-facility-view>
        <app-dobry-agent-facility-add *ngIf="modifyFacilityDobryAgent" [facility]="facility"
                                      [facilityDobryAgent]="facilityDobryAgent" [ofwcas]="ofwcas"
                                      (closeModification)="modifyFacilityDobryAgent = false; loadFacility()"></app-dobry-agent-facility-add>
      </mat-tab>
      <mat-tab label="Doradcy Placówki ">
        <app-dobry-agent-agent-list
          *ngIf="!modifyAgent"
          [ofwcas]="dobryAgentOfwcas"
          [facilityDobryAgent]="facilityDobryAgent"
          (modifyClicked)="modifyAgent = true">
        </app-dobry-agent-agent-list>

        <app-dobry-agent-agent-edit
          *ngIf="modifyAgent"
          [ofwcas]="dobryAgentOfwcas"
          [facilityDobryAgent]="facilityDobryAgent"
          (closeModification)="modifyAgent = false; loadFacility()">
        </app-dobry-agent-agent-edit>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Historia weryfikacji </span>&nbsp;
          <mat-chip *ngIf="hasPendingVerification" color="accent" selected matTooltip=" Do weryfikacji"> Do weryfikacji
          </mat-chip>

        </ng-template>
        <ng-container *ngIf="hasPendingVerification || (facilityDobryAgent | async)?.verification.length">
          <app-dobry-agent-facility-verification-list
            [facilityDobryAgentObject]="facilityDobryAgentObject"
            [verifications]="facilityDobryAgentObject?.verification || []"
            (accepted)="loadFacility()"
            (rejected)="loadFacility()"
            (edited)="loadFacility()">
          </app-dobry-agent-facility-verification-list>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [facility]="facility"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
